import { render, staticRenderFns } from "./SetDurationModal.vue?vue&type=template&id=2093714a"
import script from "./SetDurationModal.vue?vue&type=script&lang=js"
export * from "./SetDurationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports